// extracted by mini-css-extract-plugin
export default {"section":"formSection_section__2iU8Z","header":"formSection_header__KXZb5","action":"formSection_action__s7xhT","body":"formSection_body__T3dEK"};